import { render, staticRenderFns } from "./pipe-welcome.vue?vue&type=template&id=4fe8defd&scoped=true"
import script from "./pipe-welcome.vue?vue&type=script&lang=js"
export * from "./pipe-welcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe8defd",
  null
  
)

export default component.exports